import axios from "axios";

const API = axios.create({
  baseURL: "https://apimonitoreo.vspamazonas.com.co/",
  withCredentials: true,
  timeout: 12000,
});

// Adjunta el token de sesión de BAC Sarampión — SOLO en peticiones a
// /bac o /lista_bac, para no interferir con el resto del sistema (que
// usa su propio login por cookies).
API.interceptors.request.use((config) => {
  const esRutaBac = config.url?.includes("/bac") || config.url?.includes("/lista_bac");
  if (esRutaBac) {
    try {
      const sesion = JSON.parse(localStorage.getItem("bac_sesion") || "null");
      if (sesion?.token) config.headers.Authorization = `Bearer ${sesion.token}`;
    } catch { /* sesión corrupta o inexistente — sigue sin token, el backend la rechaza */ }
  }
  return config;
});

// ⚠️ MUY IMPORTANTE para el uso offline: esto SOLO cierra la sesión
// cuando el SERVIDOR responde explícitamente 401 (token vencido/inválido
// de verdad) — eso únicamente puede pasar si hubo conexión real con el
// backend. Un error de red (sin señal, timeout, servidor caído) NO tiene
// error.response — axios lo distingue solo — así que nunca se confunde
// "no hay internet" con "la sesión venció". Si no hay red, la petición
// simplemente falla y el resto de la app cae a su lógica offline normal
// (caché local, cola de sincronización, etc.), sin tocar la sesión.
API.interceptors.response.use(
  (res) => res,
  (error) => {
    const esRutaBac = error.config?.url?.includes("/bac") || error.config?.url?.includes("/lista_bac");
    const esRechazoDeSesion = error.response?.status === 401 && esRutaBac;
    if (esRechazoDeSesion) {
      window.dispatchEvent(new CustomEvent("bac-sesion-invalida"));
    }
    return Promise.reject(error);
  }
);

export default API;